import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";


const ReturnPolicy = () => {
    

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />
      {/* Preloader */}
      <Preloader />
      {/* HeaderOne */}
      <HeaderOne category={true} />
      {/* Breadcrumb */}
      <Breadcrumb title={"Return Policy"} />

      {/* Tabs for Profile, Address, and Orders */}
      <div style={{ padding: "24px", display: "flex" }}>
      <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Return Policy - Gharbar Traders</h1>
      <p className="text-gray-600">Effective Date: [Insert Date]</p>

      <p className="mt-4">
        At Gharbar Traders, we strive to provide our customers with the highest quality alcoholic beverages and a seamless shopping experience. Due to the nature of our products, we have a strict return policy in place to ensure compliance with legal regulations and maintain product integrity.
      </p>

      <h2 className="text-2xl font-semibold mt-6">Eligibility for Returns</h2>
      <ul className="list-disc pl-6 mt-2">
        <li><strong>Defective or Damaged Products:</strong> Contact us within <strong>48 hours</strong> of delivery with clear photographs.</li>
        <li><strong>Wrong Item Delivered:</strong> If you receive an incorrect item, we will arrange for a replacement or refund.</li>
        <li><strong>Expired Products:</strong> We will offer a replacement or a full refund upon verification.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">Non-Returnable Items</h2>
      <ul className="list-disc pl-6 mt-2">
        <li>Opened or partially consumed bottles.</li>
        <li>Products purchased under special discounts or promotions.</li>
        <li>Personal taste preferences.</li>
        <li>Orders where the seal or packaging has been broken.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">Return Process</h2>
      <ol className="list-decimal pl-6 mt-2">
        <li><strong>Initiating a Return:</strong> Contact our customer support within <strong>48 hours</strong>.</li>
        <li><strong>Verification:</strong> Provide clear images of the product and packaging.</li>
        <li><strong>Approval & Pickup:</strong> If approved, we will arrange for a return pickup.</li>
        <li><strong>Refund or Replacement:</strong> Processed within <strong>7-10 business days</strong> after inspection.</li>
      </ol>

      <h2 className="text-2xl font-semibold mt-6">Refund Policy</h2>
      <ul className="list-disc pl-6 mt-2">
        <li><strong>Mode of Refund:</strong> Refunds will be processed to the original payment method.</li>
        <li><strong>Processing Time:</strong> Refunds may take <strong>7-10 business days</strong> to reflect.</li>
        <li><strong>Partial Refunds:</strong> May be provided at our discretion.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">Cancellation Policy</h2>
      <ul className="list-disc pl-6 mt-2">
        <li>Orders can be canceled within <strong>2 hours</strong> of placement.</li>
        <li>If canceled after processing, a restocking fee may apply.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">Contact Us</h2>
      <p className="mt-2">For any inquiries regarding returns, refunds, or cancellations, please reach out to us:</p>
      <ul className="list-disc pl-6 mt-2">
        <li><strong>Email:</strong> [Insert Email Address]</li>
        <li><strong>Phone:</strong> [Insert Contact Number]</li>
        <li><strong>Address:</strong> [Insert Business Address]</li>
      </ul>

      <p className="mt-4">We appreciate your understanding and cooperation. Thank you for shopping with Gharbar Traders!</p>
    </div>

      </div>
      {/* FooterTwo */}
      <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ReturnPolicy;
